/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function curry(fn, n) {
  if (typeof n !== 'number') {
    n = fn.length;
  }
  function getCurryClosure(prevArgs) {
    function curryClosure() {
      for (var _len = arguments.length, _rest = new Array(_len), _key = 0; _key < _len; _key++) {
        _rest[_key] = arguments[_key];
      }
      var len = arguments.length;
      var args = [].concat(prevArgs);
      if (len) {
        args.push.apply(args, arguments);
      }
      if (n !== undefined && args.length < n) {
        return getCurryClosure(args);
      }
      return fn.apply(this, args);
    }
    return curryClosure;
  }
  return getCurryClosure([]);
}
var _default = curry;
exports.default = _default;